import React from 'react';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

interface IProps {
  lastSentAt?: string | null;
}

const LastSent: React.FC<IProps> = ({ lastSentAt }) => {
  return (
    <div>
      {lastSentAt &&
        DateFormatter({
          date: lastSentAt,
          format: DateFormats['MM-dd-yy | h:mm a'],
        })}
    </div>
  );
};

export default LastSent;
